import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Field, Form } from 'react-final-form';
import Sticky from 'react-stickynode';
import { Button } from 'reactstrap';

import Panel from '../components/Panel';
// import Range from '../components/Range';
import { useDict } from '../contexts/LanguageContext';
import useWindowSize from '../hooks/useWindowSize';
import { getThemeList } from '../modules/investNow/src/investNowApis';
import { BootstrapBreakpoints } from '../utils/constants';
import CustomInputField from './form/CustomInputField';

const InvestmentNoteFiltering = ({
    filterInvestmentNotes
}) => {
    const dict = useDict();

    const [themeFilters, setThemeFilters] = useState([]);

    useEffect(() => {
        getThemeList(handleGetThemeFilters);
    }, []);

    const handleGetThemeFilters = (response) => {
        const { data: responseData } = response.data;
        const themes = responseData.map((theme) => {
            return {
                value: theme.id,
                label: theme['name_en'],
                name: theme.slug.substring(7),
            };
        });

        setThemeFilters(themes);
    }

    const { width } = useWindowSize();

    const themeFilterValidation = (values) => {
        const errors = {};
        if (
            !values.assureFilter &&
            !values.diversifiedFilter &&
            !values.selectFilter
        ) {
            errors.alert = dict.transactionTypeEmpty;
        }
        return errors;
    };

    const isMobile = width <= BootstrapBreakpoints.SM;

    const panelColClassName = classNames({
        'pl-0 pr-3': !isMobile,
        'px-0': isMobile,
    });

    const innerActiveClass = classNames({
        'panel--sticky': isMobile,
        'mt-2': !isMobile,
    });

    const handleSubmit = (values, form) => {
        filterInvestmentNotes(values, themeFilters);
        form.initialize(values);
    };

    return (
        <Sticky
            innerActiveClass={innerActiveClass}
            top=".container"
        >
            <Panel
                xs={12}
                title={isMobile ? dict.filtering : null}
                colClassName={panelColClassName}
                collapsable={isMobile}
                panelClassName="invest-now-panel"
            >
                <Form
                    initialValues={{
                        diversifiedFilter: true,
                        selectFilter: true,
                        assureFilter: true,
                    }}
                    validate={themeFilterValidation}
                    onSubmit={(values, form) => {
                        handleSubmit(values, form);
                    }}
                >
                    {({ dirty, handleSubmit }) => (
                        <form onSubmit={handleSubmit}>
                            <div
                                style={{ marginBottom: '20px' }}
                                className="form__form-group-input-wrap"
                            >
                                <h5 className="font-weight-bold mb-3">
                                    {dict.filterByName}
                                </h5>
                                <div className="form__form-group-field">
                                    <Field name="name">
                                        {({ input, meta }) => (
                                            <CustomInputField
                                                input={input}
                                                meta={meta}
                                                type="text"
                                                placeholder={dict.enterInvestmentNoteName}
                                                inputClassName="invest-now-form__input"
                                            />
                                        )}
                                    </Field>
                                </div>
                            </div>
                            {/* <div
                                style={{
                                    marginTop: '20px',
                                    marginBottom: '30px',
                                }}
                            >
                                <h5 style={{ fontWeight: 'bold' }}>Return</h5>
                                <div className="form__form-group-field">
                                    <Field name="range">
                                        {({ input: { onChange, value } }) => (
                                            <div className="width-hundred">
                                                <Range
                                                    min={0}
                                                    max={15}
                                                    value={[
                                                        value.minValue,
                                                        value.maxValue,
                                                    ]}
                                                    onChange={onChange}
                                                    onAfterChange={onChange}
                                                />
                                            </div>
                                        )}
                                    </Field>
                                </div>
                            </div> */}
                            {/* <h5 className="font-weight-bold mb-3">
                                {dict.filterByTheme}
                            </h5>
                            {themeFilters.map((theme) => {
                                return (
                                    <div className="mb-3">
                                        <Field name={`${theme.name}Filter`} type="checkbox">
                                            {({ input, meta }) => (
                                                <CustomCheckBox
                                                    input={input}
                                                    meta={meta}
                                                    label={theme.label}
                                                />
                                            )}
                                        </Field>
                                    </div>
                                );
                            })} */}
                            <Field name="alert" type="checkbox">
                                {({ meta }) =>
                                    meta.error ? (
                                        <p className="text-danger">
                                            {meta.error}
                                        </p>
                                    ) : null
                                }
                            </Field>
                            {dirty && (
                                <Button
                                    type="submit"
                                    className="mb-0 w-100 mt-3"
                                    color="primary"
                                >
                                    {dict.apply}
                                </Button>
                            )}
                        </form>
                    )}
                </Form>
            </Panel>
        </Sticky>
    );
};

export default InvestmentNoteFiltering;
